<template>
    <div id="newUser" class="content">
            <h4>{{ title }}</h4>
            <hr>
            <div class="row">
                <div class="col-sm-11">
                    <form class="form" @submit.prevent="saveAdmin">
                        <div class="form-group row">
                            <div class="col-sm-2" >
                                <label class="control-label" for="full_name">{{ label.full_name }}</label>
                            </div>
                            <div class="col-sm-8">
                                <input type="text" class="form-control" required id="full_name" name="full_name" v-model="admin.display_name" >
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="email">{{ label.email }}</label>
                            </div>
                            <div class="col-sm-8">
                                <input type="email" class="form-control" required id="email" name="email" v-model="admin.email" >
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="password">{{ label.password }}</label>
                            </div>
                            <div class="col-sm-8">
                                <input type="password" class="form-control" id="password" name="password" v-model="admin.password" >
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="c_password">{{ label.c_password }}</label>
                            </div>
                            <div class="col-sm-8">
                                <input type="password" class="form-control" id="c_password" name="c_password" v-model="admin.confirm_password" >
                            </div>
                        </div>                        
                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="created_at">{{ label.created_at }}</label>
                            </div>
                            <div class="col-sm-3">
                                <input type="date" class="form-control" id="created_at" name="created_at" required v-model="admin.created_at" >
                            </div>
                            <div class="col-sm-2">
                                <label class="control-label" for="ended_at">{{ label.ended_at }}</label>
                            </div>
                            <div class="col-sm-3">
                                <input type="date" class="form-control" id="ended_at" name="ended_at" required v-model="admin.ended_at" >
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="is_enanbled">{{ label.is_enabled }}</label>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="is_enabled_options" id="is_enabled_yes" value="1" v-model="admin.is_enabled">
                                    <label class="form-check-label" for="inlineRadio1">{{ label.enabled_yes }}</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="is_enabled_options" id="is_enabled_no" value="0" v-model="admin.is_enabled">
                                    <label class="form-check-label" for="inlineRadio2">{{ label.enabled_no }}</label>
                                </div>
                            </div>   
                        </div>

                        <div class="form-group row text-center">
                            <div class="col-sm-11">                        
                                <button type="submit" class="btn btn-primary" >SAVE</button>
                                <router-link :to="`/${$i18n.locale}/user`"><button class="btn btn-primary">CANCEL</button></router-link>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data () {
        return {
          title: 'NEW ADMIN USER',
          label: {
                full_name: 'FULL NAME',
                email: 'EMAIL',
                password: 'PASSWORD',
                c_password: 'CONFIRM PASSWORD',                
                created_at: 'ACTIVE FROM',
                ended_at: 'ACTIVE UNTIL',
                id_number: 'ID',
                is_enabled: 'DISABLED',
                enabled_yes: 'YES',
                enabled_no: 'NO'
            },
            admin: {
                display_name: null,
                email: null,
                password: null,
                confirm_password: null,
                created_at: null,
                ended_at: null,
                is_enabled: 0
            },
            validationMsg: '',
            status: '',
        
        }
    },

    methods: {
        saveAdmin() {
            var vm = this
            let route = '/' + this.$i18n.locale + '/user'

            axios.post(this.$store.getters.rootAPI + '/admin/create', {
                email: vm.admin.email,
                password: vm.admin.password,
                confirm_password: vm.admin.confirm_password,                
                effective_at: vm.admin.created_at,
                effective_till: vm.admin.ended_at,
                display_name: vm.admin.display_name,
                is_enabled: vm.admin.is_enabled
            })
            .then(function (response) {  
                vm.status = response.data.status

                if(vm.status === 'success') {
                    vm.$router.push(route)
                }

                if(response.data.errors.length > 0)
                {
                    vm.validationMsg = response.data.errors[0].msg
                    alert('Validation error. ' + vm.validationMsg)
                }          
            })
            .catch(function (error) {
                if(error.response) {
                    vm.status = error.response.data
                    alert('An error occured. ' + vm.status)
                }
            })
        }
    },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/user/NewUser.vue